import { render, staticRenderFns } from "./Day2024.vue?vue&type=template&id=35d2a1ae"
import script from "./Day2024.vue?vue&type=script&lang=js"
export * from "./Day2024.vue?vue&type=script&lang=js"
import style0 from "./Day2024.vue?vue&type=style&index=0&id=35d2a1ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports